export enum EAppService {
  AppStore = 'AppStore',
  GooglePlay = 'GooglePlay',
  AppGallery = 'AppGallery',
}
